import React from 'react';
import './Experience.css';

const Experience = () => {
  return (
    <div className="experience">
      <section className="experience-hero section-padding">
        <div className="container-narrow">
          <h1 className="heading-1">Experience</h1>
        </div>
      </section>

      <section className="experience-content">
        <div className="container-narrow">
          <div className="experience-item">
            <h2 className="heading-2">Creative Head, J&J Junior, Vero Moda Girl and Selected</h2>
            <p className="experience-meta">Bestseller India Pvt. Ltd., Mumbai | 2022 to Present</p>
            <p className="body-regular">
              I lead the creative direction and content strategy for emerging brands, overseeing visual storytelling across e-commerce, digital platforms, and campaign ecosystems.
            </p>
            <p className="body-regular">
              My role focuses on aligning creative output with commercial performance, ensuring consistency, relevance, and scalability across multiple touchpoints.
            </p>
            <ul className="experience-highlights">
              <li>Developed and executed content strategies aligned with e-commerce channels</li>
              <li>Curated monthly trend calendars for multiple brands</li>
              <li>Led end to end content production and execution timelines</li>
              <li>Headed talent onboarding and creative team coordination</li>
              <li>Streamlined internal workflows for efficiency</li>
              <li>Drove UX/UI enhancements for improved customer experience and conversion</li>
              <li>Facilitated internal and external stakeholder alignment</li>
            </ul>
          </div>

          <div className="experience-item">
            <h2 className="heading-2">Head Stylist, Jack&Jones, Only & Sons, Produkt, AJIO B2B, J&J Junior, Vero Moda Girl</h2>
            <p className="experience-meta">Bestseller India Pvt. Ltd., Mumbai | 2015 to 2022</p>
            <p className="body-regular">
              I oversaw the visual language across multiple brands simultaneously, ensuring each retained a distinct yet commercially effective aesthetic. My work translated global trends into localized narratives that resonated with Indian consumers across platforms.
            </p>
            <ul className="experience-highlights">
              <li>Led weekly brand shoots and styled complete looks</li>
              <li>Identified and positioned high fashion pieces for digital platforms</li>
              <li>Increased sales potential by 70% through strategic content placement</li>
              <li>Independently selected and onboarded models</li>
              <li>Styled exclusive seasonal press room launches</li>
              <li>Collaborated with celebrity stylists for high profile personalities</li>
              <li>Executed 4+ weekly shoots across platforms</li>
              <li>Led seasonal merchandise launches</li>
              <li>Improved operational efficiency by automating workflows</li>
              <li>Increased website traffic through high quality visual storytelling</li>
              <li>Revived slow moving inventory through strategic styling</li>
              <li>Conceptualized and executed bi-weekly Instagram shoots</li>
              <li>Collaborated on the #DontHoldBack campaign with Ranveer Singh's stylist</li>
              <li>Developed international standard styling guidelines</li>
              <li>Curated looks for offline retail environments</li>
            </ul>
          </div>

          <div className="experience-item">
            <h2 className="heading-2">Freelance Stylist</h2>
            <p className="experience-meta">Mumbai | April 2013 to November 2014</p>
            <p className="body-regular">
              I worked across commercial and entertainment formats, collaborating with directors, production teams, and brands to deliver visually cohesive campaigns.
            </p>
            <ul className="experience-highlights">
              <li>Styled Deepika Padukone for Garnier BB Cream TVC</li>
              <li>Led styling for IPL campaigns</li>
              <li>Worked with brands including Snapdeal, Airtel, Pantene, KFC, Ceat Tyres, Molti Mattress, and Tara Jewellers</li>
              <li>Styled for 10+ national TV commercials</li>
            </ul>
          </div>

          <div className="experience-item">
            <h2 className="heading-2">Senior Stylist</h2>
            <p className="experience-meta">Dharma Productions | March 2013 to October 2013</p>
            <p className="body-regular">
              I assisted the lead stylist in sourcing, styling, and maintaining continuity for the cast of Humpty Sharma Ki Dulhania, ensuring character authenticity and visual consistency throughout production.
            </p>
            <ul className="experience-highlights">
              <li>Oversaw fittings and on-set styling</li>
              <li>Led a team of junior stylists</li>
              <li>Coordinated with direction and production teams</li>
            </ul>
          </div>

          <div className="experience-item">
            <h2 className="heading-2">Freelance Design Consultant</h2>
            <p className="experience-meta">Payal Singhal | December 2012 to January 2013</p>
            <ul className="experience-highlights">
              <li>Designed prêt collection for Blenders Pride Fashion Week</li>
              <li>Developed mood boards, color palettes, and fabric stories</li>
              <li>Managed editorial collaborations</li>
              <li>Styled campaign and catalogue shoots</li>
            </ul>
          </div>

          <div className="experience-item">
            <h2 className="heading-2">Freelance Design & Product Consultant</h2>
            <p className="experience-meta">Gavin Miguel | August 2011 to November 2013</p>
            <ul className="experience-highlights">
              <li>Designed prêt collection for Blenders Pride Fashion Week</li>
              <li>Led the embroidery department</li>
              <li>Worked closely with artisans and production teams</li>
            </ul>
          </div>

          <div className="experience-item">
            <h2 className="heading-2">Head Designer</h2>
            <p className="experience-meta">Vinegar Fashion Studio | May 2011 to July 2011</p>
            <ul className="experience-highlights">
              <li>Designed prêt collection for Middle Eastern label "La Femme"</li>
              <li>Conducted market research and trend forecasting</li>
              <li>Sourced premium fabrics and trims</li>
              <li>Created seasonal mood boards and palettes</li>
              <li>Balanced creativity with commercial viability</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Experience;
